module.exports = __webpack_public_path__ + "img/ain-logo.935a64ae.jpg";